import React from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import { MdOutlineLegendToggle } from "react-icons/md";
import Swal from "sweetalert2";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import IconUser from "../images/icon-user.png";
import IconLock from "../images/icon-lock.png";
import IconLogout from "../images/icon-logout.png";
import "./custom.scss";
import { useUser } from "../UserContext";
import { useAuth } from "../AuthProvider";

const pageTitleMap: Record<string, string> = {
  "/dashboard": "Dashboard",
  "/user-management": "User Management",
  "/users": "User Management",
  "/promocode-management": "Promocode Management",
  "/subscription-plan-management": "Subscription Plans",
  "/payments-information": "Payments Information",
  "/profile": "Profile",
  "/change-password": "Change Password",
  "/repair-shop-management": "Repair Shop Management",
  "/service-management": "Service Management",
};

interface HeaderProps {
  toggleSidebar: () => void;
  sidebarToggled: boolean;
}

const Header: React.FC<HeaderProps> = ({ toggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isLoading } = useUser();
  const { logout } = useAuth();

  const pageName =
    Object.entries(pageTitleMap).find(([path]) =>
      location.pathname.startsWith(path)
    )?.[1] || "Dashboard";

  const fullName = isLoading 
    ? ""
    : user?.firstName && user?.lastName
      ? `${user.firstName} ${user.lastName}`
      : user?.email || "Guest User";

  const handleLogout = (): void => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#08A45D",
      cancelButtonColor: "#fff",
      confirmButtonText: "Yes, Logout!",
      customClass: {
        popup: "custom-swal-popup"
      }
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Logging out...",
          icon: "info",
          showConfirmButton: false
        });

        logout();

        setTimeout(() => {
          Swal.close();
          navigate("/");
        }, 1500);
      }
    });
  };

  return (
    <Navbar className="py-3 box-shadow1 header">
      <Container fluid>
        <div
          className="sidebar-toggle"
          onClick={toggleSidebar}
          style={{ cursor: "pointer" }}
        >
          <MdOutlineLegendToggle size={24} className="text-light" />
        </div>
        <h3
          className="fw-bold ms-3 my-auto header-page-name"
          style={{ fontSize: "24px", color: "#4D5E80" }}
        >
          {pageName}
        </h3>
        <Navbar.Collapse className="justify-content-end mx-3">
          <Dropdown align="end" className="settings-block-ucr">
            <Dropdown.Toggle
              variant="link"
              id="dropdown-basic"
              className="d-flex text-decoration-none align-items-center"
            >
              {isLoading ? (
                <div
                  className="profile-loading rounded-circle d-flex align-items-center justify-content-center bg-light"
                  style={{ width: "50px", height: "50px", marginRight: "8px" }}
                >
                  <div className="spinner-border spinner-border-sm text-secondary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : user?.profileImage ? (
                <div
                  className="profile-image-container"
                  style={{
                    width: "50px",
                    height: "50px",
                    marginRight: "8px",
                    overflow: "hidden"
                  }}
                >
                  <img
                    src={user.profileImage}
                    alt="profile"
                    className="img-fluid rounded-circle w-100 h-100 object-fit-cover"
                  />
                </div>
              ) : (
                <div
                  className="profile-initials rounded-circle d-flex align-items-center justify-content-center bg-secondary text-white "
                  style={{ width: "50px", height: "50px", marginRight: "8px" }}
                >
                  {user?.firstName && user?.lastName
                    ? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`
                    : user?.email?.charAt(0).toUpperCase() || "GU"}
                </div>
              )}
              <div style={{ textAlign: "left", lineHeight: "normal" }}>
                {isLoading ? (
                  <div 
                    className="bg-light rounded" 
                    style={{ 
                      width: "120px", 
                      height: "20px",
                      animation: "pulse 1.5s ease-in-out infinite"
                    }}
                  ></div>
                ) : (
                  <p className="text-dark m-0 text-left fw-bold">{fullName}</p>
                )}
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu className="border-0 shadow mt-3 py-3">
              <Dropdown.Item className="px-4 mb-2">
                <Link
                  to="/profile"
                  className="text-decoration-none text-light gilroy-semibold"
                >
                  <img src={IconUser} className="me-2" alt="user" />
                  Profile
                </Link>
              </Dropdown.Item>
              <Dropdown.Item className="px-4 mb-2">
                <Link
                  to="/change-password"
                  className="text-decoration-none text-light gilroy-semibold"
                >
                  <img src={IconLock} className="me-2" alt="lock" />
                  Change Password
                </Link>
              </Dropdown.Item>
              <Dropdown.Item
                onClick={handleLogout}
                className="text-light px-4 gilroy-semibold"
              >
                <img src={IconLogout} className="me-2" alt="logout" />
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
